export default __webpack_public_path__ + "static/media/edits-icon.0fe5c48a.svg";